import React, { memo, useMemo, useState, useCallback } from 'react';
import { Progress, Typography } from '../../../../../../../components';
import { getGiBfromMiBOneDecimal, getStatusBarColor } from '../../../../../../../lib/helpers';
import { getCriteriaIcon } from './CriteriaIcons';
import { DownOutlined, RightOutlined, HomeOutlined, MenuOutlined } from '@ant-design/icons';

import './StorageAndMemoryCriteria.scss';

const { Text } = Typography;

export const StorageCriteria = memo(({ criteria, total, used, disks, disksUsed, storageUtilization }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const usedValue = getGiBfromMiBOneDecimal(used);
    const totalValue = getGiBfromMiBOneDecimal(total);
    const percent = useMemo(() => {
        return totalValue ? (usedValue / totalValue) * 100 : 0;
    }, [usedValue, totalValue]);

    const hasDisks = Array.isArray(disks) && disks.length > 0;

    const handleExpandClick = (e) => {
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="storage-and-memory-criteria">
            <div
                className="label-row"
                onClick={hasDisks ? handleExpandClick : undefined}
                style={{ cursor: hasDisks ? 'pointer' : 'default' }}
            >
                <Text className="progress-bar-label">
                    Total Free:
                    <Text className="semi-bold storage-progress-value">
                        {criteria ? ` ${Number(totalValue - usedValue).toFixed(1)} GiB` : ' N/A'}
                    </Text>
                    {getCriteriaIcon(criteria)}
                </Text>
                {hasDisks && (isExpanded ? <DownOutlined /> : <RightOutlined />)}
            </div>
            <Progress
                percent={percent}
                showInfo={false}
                strokeColor={getStatusBarColor(criteria)}
                format={() => `${usedValue} / ${totalValue}`}
            />
            {isExpanded && hasDisks && (
                <div className="storage-breakdown">
                    <Text className="storage-breakdown-title bold">Storage Breakdown</Text>
                    {disks.map((disk, index) => {
                        return (
                            <div key={index} className="disk-row">
                                <div className="single-disk-label-row">
                                    <Text className="disk-label">
                                        {index === 0 ? <HomeOutlined /> : <MenuOutlined />} Disk {index}
                                        {getCriteriaIcon(storageUtilization[index])}
                                    </Text>
                                    <Text className="disk-usage">
                                        Used:{' '}
                                        {disksUsed[index] ? `${getGiBfromMiBOneDecimal(disksUsed[index])} GiB` : ' N/A'}{' '}
                                        / {disk ? `${getGiBfromMiBOneDecimal(disk)} GiB` : 'N/A'}
                                    </Text>
                                </div>
                                <Progress
                                    percent={percent}
                                    showInfo={false}
                                    strokeColor={getStatusBarColor(storageUtilization[index])}
                                />
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
});
